import dayjs, { Dayjs } from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePickerWrapper, StyledDatePicker, StyledDatePickerContainer } from './DatePickerStyle';
import { IconButton, InputAdornment } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import CalendarIcon from '../icons/CalendarIcon';

dayjs.extend(utc);
export interface DatePickerProps {
  minDate: Dayjs | null | unknown;
  maxDate?: Dayjs | null | unknown;
  value: Dayjs | null | unknown;
  dateChangeHandler: (date: Dayjs) => void;
  showIcon?: boolean;
  isStyledForFormDatePicker?: boolean
}

export default function DatePicker({
  minDate,
  maxDate,
  value,
  dateChangeHandler,
  showIcon = false,
  isStyledForFormDatePicker = false,
  ...rest
}: DatePickerProps) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} {...rest}>
      <StyledDatePickerContainer components={['DesktopDatePicker']}>
        <DatePickerWrapper>
          <StyledDatePicker
            closeOnSelect={true}
            className='date-range-picker-field'
            disableHighlightToday={true}
            minDate={dayjs.utc(String(minDate)).local()}
            maxDate={dayjs.utc(String(maxDate)).local()}
            value={value !== null ? dayjs.utc(String(value)).local() : null}
            onChange={(date?: Dayjs | unknown) => {
              dateChangeHandler(dayjs(String(date)));
            }}
            slotProps={{
              textField: {
                placeholder: '-- / -- / --',
                InputProps: {
                  startAdornment: showIcon ? (
                    <InputAdornment position='start'>
                      <IconButton edge='start' size='small' sx={{
                        marginLeft: '0px',
                        paddingLeft: '0px'
                      }}>
                        <CalendarIcon />
                      </IconButton>
                    </InputAdornment>
                  ) : null,
                },
              },
            }}
            timezone='system'
            isStyledForFormDatePicker={isStyledForFormDatePicker}
          />
        </DatePickerWrapper>
      </StyledDatePickerContainer>
    </LocalizationProvider>
  );
}
